import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

// Import JSON files
import en from "./locales/en.json";
import fr from "./locales/fr.json";
import de from "./locales/de.json";
import es from "./locales/es.json";
import it from "./locales/it.json";

const messages = {
  en,
  fr,
  de,
  es,
  it,
};

export default function createI18n() {
  const savedLocale = localStorage.getItem("locale");

  const browserLocale = (navigator.language || "en").split("-")[0];

  const locale = savedLocale || (messages[browserLocale] ? browserLocale : "en");

  return new VueI18n({
    locale,
    fallbackLocale: "en",
    silentTranslationWarn: true,
    messages,
  });
}
